import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDownlines = () => useQuery({ queryKey: [`downlines`], queryFn: async () => {
    const callback = await API.get(`/downlines`)
    return callback?.data
}})

export default useDownlines